import { styled } from 'styled-components';

// Subtitle must be bold and underlined
export const St = styled.dt`
  font-weight: bold;
  text-decoration: underline;
`;
